import logo from "../assets/emisaathi-logo.png";
import "./container.css";
import "./Footer.css";

const MailIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" className="footer-contact-icon">
    <path d="M4 4h16v16H4z" stroke="none" />
    <path
      d="M4 6h16a1 1 0 011 1v10a1 1 0 01-1 1H4a1 1 0 01-1-1V7a1 1 0 011-1z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path d="M4 7l8 6 8-6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const PhoneIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" className="footer-contact-icon">
    <path
      d="M6.6 10.8c1.4 2.8 3.8 5.2 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.9 21 3 13.1 3 3.9c0-.6.4-1 1-1h3.4c.6 0 1 .4 1 1 0 1.2.2 2.4.6 3.6.1.3 0 .7-.2 1L6.6 10.8z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const PinIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" className="footer-contact-icon">
    <path
      d="M12 21s7-6.5 7-12a7 7 0 10-14 0c0 5.5 7 12 7 12z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="9" r="2.5" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);

const QUICK_LINKS = [
  { label: "Home", href: "/" },
  { label: "How It Works", href: "/#how-it-works" },
  { label: "About Us", href: "/about" },
  { label: "Contact Us", href: "/contact" },
];

const RBI_LINKS = [
  { label: "Fair Practice Code", href: "/fair-practice-code" },
  { label: "RBI Sachet Portal", href: "https://sachet.rbi.org.in/", external: true },
  { label: "Grievance Redressal Mechanism", href: "/grievance-redressal" },
];

const REGISTERED_ADDRESS = "H-144, Sector 63, Noida, Uttar Pradesh, India - 201309";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container-8xl">
        <div className="footer-top">
          <div>
            <img src={logo} alt={`${import.meta.env.VITE_COMPANY_NAME}`} className="footer-brand-logo" />
            <p className="footer-brand-tagline">
              Simplifying debt. Empowering better financial decisions.
            </p>
          </div>

          <div>
            <h3 className="footer-col-title">Quick Links</h3>
            <div className="footer-links">
              {QUICK_LINKS.map((link) => (
                <a key={link.label} href={link.href} className="footer-link">
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="footer-col-title">RBI</h3>
            <div className="footer-links">
              {RBI_LINKS.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  className="footer-link"
                  target={link.external ? "_blank" : undefined}
                  rel={link.external ? "noreferrer" : undefined}
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="footer-col-title">Contact Us</h3>
            <div className="footer-links">
              <span className="footer-contact-item">
                <MailIcon />
                {import.meta.env.VITE_COMPANY_EMAIL}
              </span>
              <span className="footer-contact-item">
                <PhoneIcon />
                {import.meta.env.VITE_COMPANY_PHONE}
              </span>
              <span className="footer-contact-item">
                <PinIcon />
                {REGISTERED_ADDRESS}
              </span>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <span className="footer-bottom-item">
            <strong>NBFC Partner:</strong> Naman Finlease Pvt. Ltd.
          </span>
          <span className="footer-bottom-item">
            <strong>RBI NBFC License:</strong> 14.01466
          </span>
          <span className="footer-bottom-item">
            <strong>Powered By:</strong> Fintech Cloud Private Limited
          </span>
          <span className="footer-bottom-item">
            <strong>Registered Address:</strong> {REGISTERED_ADDRESS}
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
